import * as Yup from 'yup';

export const validationSchema = Yup.object({
  phase: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  })
    .required('Required')
    .nullable(),
  lineItem: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
    amount: Yup.number(),
  })
    .required('Required')
    .nullable(),
  budgetedAmount: Yup.number().required('Required'),
  proposedAmount: Yup.number().required('Required'),
  impact: Yup.number(),
  responseDueBy: Yup.string().required('Required'),
  notes: Yup.string().required('Required'),
  reason: Yup.string().required('Required'),
  noResponseConsequence: Yup.string().required('Required'),
  templateDocuments: Yup.array(),
  recentFiles: Yup.array(),
});

export type BudgetChangeOrderSchema = Yup.InferType<typeof validationSchema>;
